import type { IModalProgressConfig, TypeBuildReturn } from './types';

import ProgressManager from './progressManager';

// ----------------------------------------------------------------------------

const progressManager = new ProgressManager();

function start(config: IModalProgressConfig = {}): TypeBuildReturn | undefined {
    return progressManager.start(config);
}

function stop(): void {
    progressManager.stop();
}

function update(value: number | string): void {
    progressManager.update(value);
}

// ----------------------------------------------------------------------------

export { start, stop, update };
